import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './plugins/router'
import i18n from '@/lang/index'
import "./plugins/components";
import vueScrollactive from 'vue-scrollactive'

Vue.use(vueScrollactive)

Vue.config.productionTip = false


Vue.config.productionTip = false
new Vue({
    i18n,
    vuetify,
    router,
    render: h => h(App)
}).$mount('#app')
